import { fetchCashFlow, updateCashFlow } from "@/modules/finances/cash-flows/services/cash-flows.services"
import UpsertForm from "@/modules/finances/cash-flows/views/UpsertForm"
import { notificationAction, notificationUpdateSuccess } from "@/utils"
import { NotificationEnum } from "@/utils/constants"
import { useGoBack } from "@/utils/use-go-back"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

export const UpdateCashFlow = () => {
  const { id } = useParams()
  const [visible, setVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [initialData, setInitialData] = useState<any>(null)

  useEffect(() => {
    const loadData = async () => {
      if (id) {
        try {
          const response = await fetchCashFlow(id)
          setInitialData(response.data)
          setVisible(true)
        } catch (error) {
          console.error("Error loading data:", error)
          notificationAction(`Lỗi khi tải dữ liệu: ${error}`, NotificationEnum.ERROR)
        }
      }
    }
    loadData()
  }, [id])
  
  const { goBack } = useGoBack("/finances/money-sources")

  const onCancel = () => {
    setVisible(false)
    goBack()
  }

  const onSubmit = async (data: any) => {
    if (!id) return
    setLoading(true)
    try {
      const response = await updateCashFlow(id, data)
      if (response.statusCode === 200) {
        notificationUpdateSuccess()
        onCancel()
      }
    } catch (error) {
      console.error("Update failed:", error)
      notificationAction(`Lỗi ${error}`, NotificationEnum.ERROR)
    } finally {
      setLoading(false)
    }
  }
  
  return (
    <UpsertForm
      visible={visible}
      onCancel={onCancel}
      onSubmit={onSubmit}
      loading={loading}
      mode="update"
      initialData={initialData}
    />
  )
} 